import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../../../contexts/userContext';

const SuperAdminRoute = () => {
  const { user } = useUser();

  return Number(user?.access_level) === 8
    ? <Outlet />
    : <Navigate to="/home" replace />;
};

export default SuperAdminRoute;
